// Rule for expiry dates on credit cards ex: 12/2025
import { findRule } from '../Utils'
const filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;

const validate = vObj => {
  let value = vObj.value
  let rule = findRule(vObj.errorBag, 'is_email')
  rule.feedback = `${vObj.fieldlabel} should be and email address in the format someone@example.com`

  const testValue = val => {
    const strValue = String(val)

    return filter.test(strValue)
  }

  if (Array.isArray(value)) {
    return value.every(testValue)
  }

  return testValue(value)
}

export { validate }

export default {
  validate
}
